module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/add-package-category/add-package-category.component.css
// module id = ./src/app/add-package-category/add-package-category.component.css
// module chunks = main